<template>
    <div style="width: 500px">
        <el-upload class="upload" ref="upload" 
        :action="$fileUpLoadUrl" :on-change="handleUploadChange"
        :on-preview="handlePreview" 
        :on-remove="handleRemove" :file-list="fileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload" v-if="fileList && fileList.length > 0" :loading="isPending">上传</el-button>
            <!-- 在这里添加插槽 -->
            <template v-if="filePath">
                <slot name="after-upload-button"></slot>
            </template>
        </el-upload>
    </div>
</template>

<script>
export default {
    props: { 
        status: {
            type: String,
            default: 'credit' //Receipt
        },
        fileList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            filePath: '',
            isPending: false
        };
    },
    mounted() {
        // this.fileList = [];
        this.filePath = '';
    },
    methods: {
        handleUploadChange(file) {
            this.fileList = [{ ...file }];
        },
           handlePreview(file) {
            // 如果文件已上传且有 URL，直接打开预览
            if (file.url) {
                window.open(file.url, '_blank');
                return;
            }
            // 处理本地未上传文件的预览
            if (file.raw) {
                const fileType = file.raw.type.split('/')[0];
                const fileName = file.raw.name;

                // 图片类型直接预览
                if (fileType === 'image') {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.$alert(`<img src="${e.target.result}" style="max-width: 100%"/>`, '图片预览', {
                            dangerouslyUseHTMLString: true,
                            showConfirmButton: false,
                            customClass: 'preview-modal'
                        });
                    };
                    reader.readAsDataURL(file.raw);
                }
                // PDF 文件预览
                else if (fileName.toLowerCase().endsWith('.pdf')) {
                    const pdfUrl = URL.createObjectURL(file.raw);
                    window.open(pdfUrl, '_blank');
                }
                // 其他文件类型提示下载
                else {
                    this.$confirm(`文件类型 ${fileType} 不支持直接预览，是否下载文件？`, '预览提示', {
                        confirmButtonText: '下载',
                        cancelButtonText: '取消',
                        type: 'info'
                    }).then(() => {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(file.raw);
                        link.download = fileName;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    });
                }
            }
        },
        submitUpload() {
            this.getFileUpLoad();
        },
        async getFileUpLoad() {
            this.isPending = true;
            // 创建 FormData 对象
            const formData = new FormData();
            formData.append('file', this.fileList[0].raw); // 通过append向form对象添加数据
            formData.append('path', this.status);
            try {
                // 发送 POST 请求
                const response = await this.$axios.post(this.$base_url + '/rest/OfficeAPI/FileUpLoad_Local', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.isPending = false;
                if (response.data.Resultcode == 0) {
                    this.$emit('onSuccess', response.data.data);
                    this.filePath = response.data.data;
                    this.$message({
                        showClose: true,
                        message: '上传成功',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: response.data.Resultinfo || '上传失败',
                        type: 'warning'
                    });
                }
            } catch (error) {
                this.isPending = false;
                this.$message({
                    showClose: true,
                    message: error || '上传失败',
                    type: 'warning'
                });
                console.error('文件上传失败:', error);
            }
        },
        handleRemove() {
            this.$emit('removeFile');
            this.fileList = [];
            this.filePath = '';
        }
    }
};
</script>

<style>
</style>